import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { CrmDigitalSolicitacaoParams, CrmDigitalSolicitacaoResponse, CrmDigitalStatusResponse } from './crm-digital.model';

@Injectable({ providedIn: 'root' })
export class CrmDigitalService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.crmDigital.solicitacoes;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultarStatus(params: CrmDigitalSolicitacaoParams, context?: HttpContext): Observable<CrmDigitalStatusResponse> {
        return this.http.get<CrmDigitalStatusResponse>(`${this.PATH}/status`, { params: this.toHttpParams(params), context });
    }

    enviarSolicitacao(params: CrmDigitalSolicitacaoParams, context?: HttpContext): Observable<CrmDigitalSolicitacaoResponse> {
        return this.http.post<CrmDigitalSolicitacaoResponse>(this.PATH, null, { params: this.toHttpParams(params), context });
    }

    private toHttpParams(params: CrmDigitalSolicitacaoParams): HttpParams {
        const values: Record<string, string> = {
            id: String(params.id),
            uf: params.uf
        };

        this.add(values, 'emitir_cim', params.emitirCim);
        this.add(values, 'emitir_cpm', params.emitirCpm);
        this.add(values, 'emitir_cd', params.emitirCd);
        this.add(values, 'tipo_carteira', params.tipoCarteira);
        this.add(values, 'pre_solicitacao', params.preSolicitacao);
        this.add(values, 'tipo_requisicao_cim', params.tipoRequisicaoCim);
        this.add(values, 'motivo_reimpressao_cim', params.motivoReimpressaoCim);
        this.add(values, 'tipo_requisicao_cpm', params.tipoRequisicaoCpm);
        this.add(values, 'motivo_reimpressao_cpm', params.motivoReimpressaoCpm);
        this.add(values, 'tipo_requisicao_cd', params.tipoRequisicaoCd);
        this.add(values, 'motivo_reimpressao_cd', params.motivoReimpressaoCd);
        this.add(values, 'nome_operador', params.nomeOperador);
        this.add(values, 'cpf_operador', params.cpfOperador);

        return new HttpParams({ fromObject: values });
    }

    private add(values: Record<string, string>, key: string, value: string | boolean | undefined): void {
        if (value === undefined || value === null || value === '') {
            return;
        }
        values[key] = String(value);
    }
}
